module.exports = __webpack_public_path__ + "static/media/cv.e5c92ef6.svg";